import { Injectable } from '@angular/core';
import { AppConfig } from '../../helper/config/api.config';
import { Observable } from 'rxjs';
import { DataService } from '../../../../../Autofacets-Core/src/app/services/data.service';
import { GenericResponse } from 'projects/Autofacets-Core/src/app/business-entities/generic-response.class';
import { Application } from 'projects/Autofacets-Core/src/app/utils/enums';

@Injectable({
  providedIn: 'root'
})
export class CommonLocalizationService {

  constructor(private dataProvider: DataService) { }

  getAllLanguages(): Observable<any> {
    return this.dataProvider.Get(AppConfig.GET_COMMON_LOCALIZATION_LANGUAGE_API_URL);
  }

  getLocalizationData(languageCode: string): Observable<any> {
    return this.dataProvider.GetNonEnc(AppConfig.GET_ADMIN_LOCALIZATION_API_URL, Application[Application.StatusTracker], languageCode);
  }

  GetGenericSettings(): Promise<GenericResponse<any>> {
    return this.dataProvider.Get<any>(AppConfig.GetGenericSettings).toPromise();
  }

  GetSettings(): Promise<GenericResponse<any>> {
    return this.dataProvider.Get<any>(AppConfig.GetSettings).toPromise();
  }

  public getFeatures(): Promise<GenericResponse<any>> {
    return this.dataProvider.GetAll<any>(AppConfig.GetFeature).toPromise();
  }

}
